import React from 'react';
import { C } from '../constants/theme';
import { NAV_ITEMS } from '../components/Sidebar';

const cardStyle = {
  background: C.white, borderRadius: 12, border: `1px solid ${C.border}`,
  boxShadow: '0 1px 4px rgba(0,0,0,.06)', overflow: 'hidden',
};

function StatCard({ label, value, icon, color }) {
  return (
    <div style={{ ...cardStyle, display: 'flex', alignItems: 'center', gap: 16, padding: 20 }}>
      <div style={{
        width: 48, height: 48, borderRadius: 12,
        background: color + '20', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 22,
      }}>
        {icon}
      </div>
      <div>
        <div style={{ fontSize: 26, fontWeight: 800, color: C.text }}>{value}</div>
        <div style={{ fontSize: 13, color: C.textMuted }}>{label}</div>
      </div>
    </div>
  );
}

const STATS = [
  { label: 'Content Categories', value: 24, icon: '🏷️', color: C.primary },
  { label: 'View Types', value: 18, icon: '🎨', color: '#3B82F6' },
  { label: 'Containers', value: 20, icon: '📦', color: '#10B981' },
  { label: 'Master Layouts', value: 25, icon: '🗂️', color: '#F4A300' },
];

export function DashboardHome({ onNav }) {
  return (
    <div>
      <div style={{ marginBottom: 24 }}>
        <h2 style={{ margin: 0, fontSize: 22, fontWeight: 700, color: C.text }}>Feed Provider Dashboard</h2>
        <p style={{ margin: '4px 0 0', fontSize: 13, color: C.textMuted }}>
          Manage your content pipeline — categories, view types, containers, and layouts
        </p>
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: 16, marginBottom: 28 }}>
        {STATS.map((s) => <StatCard key={s.label} {...s} />)}
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16 }}>
        {NAV_ITEMS.slice(1).map((item) => {
          const Icon = item.icon;
          return (
            <div
              key={item.key}
              style={{ ...cardStyle, padding: 24, cursor: 'pointer', transition: 'box-shadow .2s' }}
              onClick={() => onNav(item.key)}
              onMouseEnter={(e) => (e.currentTarget.style.boxShadow = '0 6px 24px rgba(108,63,197,.15)')}
              onMouseLeave={(e) => (e.currentTarget.style.boxShadow = cardStyle.boxShadow)}
            >
              <div style={{
                width: 44, height: 44, borderRadius: 12,
                background: '#F5F3FC',
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                marginBottom: 12,
              }}>
                <Icon size={22} strokeWidth={1.8} color={C.primary} />
              </div>
              <h3 style={{ margin: '0 0 4px', fontSize: 16, fontWeight: 700, color: C.text }}>{item.label}</h3>
              <p style={{ margin: 0, fontSize: 13, color: C.textMuted }}>
                Manage and configure {item.label.toLowerCase()} entries
              </p>
            </div>
          );
        })}
      </div>
    </div>
  );
}